import { IconProps } from '.';

export const CheckedSquareIcon = ({ className, color = '#3C3C3C' }: IconProps) => (
  <svg className={className} width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M4.5 0.75H13.5C15.5711 0.75 17.25 2.42893 17.25 4.5V13.5C17.25 15.5711 15.5711 17.25 13.5 17.25H4.5C2.42893 17.25 0.75 15.5711 0.75 13.5V4.5C0.75 2.42893 2.42893 0.75 4.5 0.75Z'
      stroke={color}
      strokeWidth='1.5'
    />
    <path
      d='M12 3C13.6569 3 15 4.34315 15 6V12C15 13.6569 13.6569 15 12 15H6C4.34315 15 3 13.6569 3 12V6C3 4.34315 4.34315 3 6 3H12ZM8.16016 9.61914L6.89062 8.34961L5.83008 9.41016L8.16016 11.7402L8.69043 11.21L12.4111 7.49023L11.8799 6.95996L11.3496 6.42969L8.16016 9.61914Z'
      fill={color}
    />
  </svg>
);
